__turbopack_context__.v({
  "badge": "StatusBadge-module-scss-module__JC9D_q__badge",
  "blue": "StatusBadge-module-scss-module__JC9D_q__blue",
  "green": "StatusBadge-module-scss-module__JC9D_q__green",
  "grey": "StatusBadge-module-scss-module__JC9D_q__grey",
  "lightBlue": "StatusBadge-module-scss-module__JC9D_q__lightBlue",
  "lightGreen": "StatusBadge-module-scss-module__JC9D_q__lightGreen",
  "lightRed": "StatusBadge-module-scss-module__JC9D_q__lightRed",
  "lightyellow": "StatusBadge-module-scss-module__JC9D_q__lightyellow",
  "red": "StatusBadge-module-scss-module__JC9D_q__red",
  "yellow": "StatusBadge-module-scss-module__JC9D_q__yellow",
});
